import { render, staticRenderFns } from "./UserRule.vue?vue&type=template&id=4c8ad5f9&"
import script from "./UserRule.vue?vue&type=script&lang=js&"
export * from "./UserRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports